export const API = 'https://api.egyptscience-srge.com';